import { createAction } from 'typesafe-actions';
import { IUser } from '../../types/model/user';

export default class UserManagementActions {
    public static setUsers = createAction('USERS_SET_USERS', resolve => (list : Array<IUser>) => resolve(list));
    public static setUser = createAction('USERS_SET_USER', resolve => (user ?: IUser) => resolve(user));
    public static setIsLoading = createAction('USERS_SET_LOADING', resolve => (isLoading : boolean) => resolve(isLoading));
}
